module.exports = __webpack_public_path__ + "img/1.215c8c13.png";